import type { StageSettingsT } from './types';
export const DEFAULT_STAGE_SETTINGS: StageSettingsT = {
  x: 0,
  y: 0,
  // scale 0 - 1 (number) - reference https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/scale
  scale: 1,
  // Rotation in degree - 0 to 360 deg - reference https://developer.mozilla.org/en-US/docs/Web/CSS/transform-function/rotate
  rotation: 0
};
export const DISPATCH_THROTTLE_WAIT = 200; // 200 milliseconds